import tenantData from '@data';
import tenantConstants from '@constants';
import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { CustomCard, DrawerModal, LinkWithIcon } from '../../../../components/common';
import AccountManager from '../../../../components/manager-info/manager-info.js';
import {
  faqSectionClickEvent,
  profolioButtonClickEvent,
  regaComplianceClickEvent,
} from '../../../../services/analyticsService/index.js';
import { IconSwitch } from '../../../../components/svg.js';
import tenantTheme from '@theme';

export const HelpAndSupport = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const { isMobile, isMemberArea, locale } = useSelector((state) => state.app.AppConfig);
  const { user } = useSelector((state) => state.app.loginUser);
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    show: (value) => {
      setVisible(value);
    },
  }));

  const cardData = useMemo(
    () => [
      {
        avatarIcon: 'ProfileIcon',
        title: t('Profolio'),
        description: t('Discover more about Profolio. Our best-in-class listings management software.'),
        link: `${tenantData.helpAndSupportUrls?.aboutProfolio?.[locale]}?webview=1`,
        onClick: profolioButtonClickEvent,
      },
      ...(tenantConstants.SHOW_REGA_DETAIL
        ? [
            {
              avatarIcon: 'SecurityIcon',
              title: t('REGA Compliance'),
              description: t('Discover more about REGA and real estate regulations.'),
              link: `${tenantData.helpAndSupportUrls?.aboutRega?.[locale]}?webview=1`,
              onClick: regaComplianceClickEvent,
            },
          ]
        : []),
      {
        avatarIcon: 'FAQIcon',
        title: t("FAQ's"),
        description: t('Explore answers to frequently asked questions and have your issues resolved.'),
        link: `${tenantData.helpAndSupportUrls?.faqs?.[locale]}?webview=1`,
        onClick: faqSectionClickEvent,
      },
    ],
    [locale],
  );
  return (
    <DrawerModal
      title={t('Help & Support')}
      visible={visible}
      onCancel={() => setVisible(false)}
      bodyStyle={{ padding: isMobile ? 12 : 24 }}
      footer={null}
      {...props}
    >
      <div>
        {cardData.map((card, i) => (
          <React.Fragment key={i}>
            <CustomCard
              // key={card?.title}
              avatarIcon={card.avatarIcon}
              title={card.title}
              description={card.description}
              link={card.link}
              onClick={card.onClick}
              extraContent={
                <LinkWithIcon
                  as="a"
                  icon={<IconSwitch color={tenantTheme['primary-color']} />}
                  href={card?.link}
                  className="btnLink"
                  target="_blank"
                />
              }
            />
          </React.Fragment>
        ))}
        {tenantConstants.SHOW_ACCOUNT_MANAGER && !isMemberArea && <AccountManager user={user} />}
      </div>
    </DrawerModal>
  );
});
